import React, { useRef, useState } from 'react';
import { Box, Popover, Typography, IconButton, useTheme } from '@mui/material';

import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const DeleteConfirm = ({
  confirm = () => null,
  disabled = false,
  isHide = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<any>(null);
  const theme = useTheme();

  const handleClose = () => {
    setIsOpen(false);
  };

  return !isHide ? (
    <>
    
      <IconButton
        ref={ref}
        sx={{
          '&:hover': {
            background: theme.colors.error.lighter
          },
          color: theme.palette.error.main
        }}
        color="inherit"
        size="small"
        onClick={() => setIsOpen(true)}
        disabled={disabled}
      >
        <DeleteTwoToneIcon fontSize="medium" />
      </IconButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <Box
          sx={{
            pl: 1,
            pr: 1,
            pt: 1
          }}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h5" color="red">Are you sure</Typography>
        </Box>
        <Box sx={{ p: 1 }} display="flex" justifyContent="space-between">
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon color="error" fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => {
              confirm();
              handleClose();
            }}
          >
            <CheckIcon color="success" fontSize="small" />
          </IconButton>
        </Box>
      </Popover>
    </>
  ) : null;
};

export default DeleteConfirm;
